<template>
  <section>
    <a v-if="anchorId" :id="anchorId" :style="top && { top: `-${top}` }" :class="$style.anchor"></a>
    <slot />
  </section>
</template>

<script setup lang="ts">
import { AnchorLinks } from '@/types';

interface Props {
  anchorId?: AnchorLinks | undefined;
  top?: string;
}

withDefaults(defineProps<Props>(), {
  anchorId: undefined,
  top: '',
});
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.anchor {
  position: relative;
  top: -$space-150;
  display: block;
  visibility: hidden;
}
</style>
